// extracted by mini-css-extract-plugin
export var buttonsContainer = "CodeVariants-module--buttons-container--1j60V";
export var button = "CodeVariants-module--button--1ef5h";